import React, { useEffect } from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import "dayjs/locale/ru";
import "dayjs/locale/en";
import "dayjs/locale/tr";
import "dayjs/locale/ar";
import "dayjs/locale/hy-am";

type AppLocalizationProviderProps = {
  children: React.ReactNode;
};

const dayjsLocaleMap: Record<string, string> = {
  ru: "ru",
  en: "en",
  tr: "tr",
  ar: "ar",
  hy: "hy-am",
};

const AppLocalizationProvider = ({
  children,
}: AppLocalizationProviderProps) => {
  const { i18n } = useTranslation();

  const language = (i18n.language || "ru").split("-")[0];
  const locale = dayjsLocaleMap[language] || "ru";

  useEffect(() => {
    dayjs.locale(locale);
  }, [locale]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
      {children}
    </LocalizationProvider>
  );
};

export default AppLocalizationProvider;
